
( function(root, factory) {

    module.exports = factory( root.jQuery );

} )( window || this, function( $ ) {
    'use strict';

    /* Global variables */
    var w = window;

    var blookbook_modal_quickview_el = function(opts) {
        var _opts = $.extend({
            ajax: true,
            custom_class: '',
            on_open_callback () { return; },
            on_close_callback () { return; },
        }, opts);

        /* modal create */
        var modal_template = `<a href="#" class="close-button"><span class="">×</span></a>
        <div class="blookbook-modal-content">
            <div class="blookbook-modal-body"></div>
        </div>`;

        var $modal = $( '<div>', {
            class: ['blookbook-modal-quickview-container', _opts.extra_class].join(' '),
            html: modal_template,
        } )

        $modal.on( {
            '__update_content.bookbook-modal' (e, content) {
                $(this).find( '.blookbook-modal-body' ).html( content );
            },
            '__open.bookbook-modal' (e) {
                _opts.on_open_callback.call( this, $(this) );

                var classes = ['is_open'];
                if( true == _opts.ajax ) classes.push( 'is-ajax-loading' );

                $(this).addClass( classes.join( ' ' ) );
            },
            '__close.bookbook-modal' (e) {
                $(this).addClass( 'is_open' );
                _opts.on_close_callback.call( this, $(this) );
                $(this).removeClass( 'is_open' );
            },
            '__remove_classes_ajax.bookbook-modal' (e) {
                e.preventDefault();
                $(this).removeClass( 'is-ajax-loading' );
            }
        } )

        /* close modal */
        $modal.on( 'click.bookbook-modal=close', '.close-button', function(e) {
            e.preventDefault();
            $modal.trigger( '__close.bookbook-modal' );
        } )

        /* get opts */
        this.get_opts = function() {
            return _opts;
        }

        $('body').append( $modal );
        return $modal;
    }

    var blookbook_lightbox_quickview = function($el, opts) {
        'use strict';
        
        var _opts = $.extend({
            handle: '.blookbook-lightbox-quickview-handle',
            on_ajax_success_callback () { return; }
        }, opts)

        /* modal */
        var modal_opts = {

        };
        var $modal = new blookbook_modal_quickview_el( modal_opts );
        
        $el.on({
            '__open.quickview' (e, id) {
                var self = this;
                $modal.trigger( '__open.bookbook-modal' );

                $.ajax({
                    type: 'POST',
                    url: blookbook_ajax_object.ajax_url,
                    data: { action: 'blookbook_ajax_get_content_lightbox_quickview', pid: id },
                    success (res) {
                        $modal.trigger( '__remove_classes_ajax.bookbook-modal' );

                        if( true == res.success ) {
                            $modal.trigger( '__update_content.bookbook-modal', [res.data.content] );
                            _opts.on_ajax_success_callback.call( self, $(self), res, $modal )
                        }
                    },
                    error (err) {
                        console.log(err);
                    }
                })
            },
        })
    
        $el.on('click.quickview', _opts.handle,function(e) {
            e.preventDefault();
                var $handle_el = $(this);
                var pid = $handle_el.data('blookbook-post-id');
            
            $el.trigger( '__open.quickview', [pid] );
        })

        /* saving modal el */
        $el.data( 'blookbook-modal-el', $modal );
    
        return $el;
    }

    return blookbook_lightbox_quickview;
} )